import { mdiLightbulb } from "@mdi/js";

const rmrAi = [
  {
    title: "RMR Ai",
    icon: mdiLightbulb,
    children: [
      {
        title: "🔍 Veille globale",
        children: [
          {
            title: "Recherche",
            to: "newsradar-db",
            resource: ["news_radar", "leparisien_editorialink"],
            action: ["manage", "read"],
          },
          {
            title: "Demande d'ajout de sources",
            to: "newsradar-source-request",
            resource: "news_radar",
            action: "manage",
          },
          {
            title: "Configuration",
            to: "newsradar-config",
            resource: "all",
            action: "manage",
          },
        ],
      },
      {
        title: "🤖 Mon rédacteur IA",
        // Le groupe parent ne voit que ses enfants directs : sans ACL ici,
        // "RMR Ai" resterait masqué pour un profil ctc seul. Union des ACL
        // des enfants ; chaque enfant garde sa propre permission.
        resource: [
          "ai_factory",
          "leparisien_editorialink",
          "ai_factory_full_auto",
          "all",
          "ctc",
        ],
        action: ["read", "manage"],
        children: [
          {
            title: "Créer post par angle",
            to: "ai-factory-generate-post",
            resource: "ai_factory",
            action: "read",
          },
          {
            title: "Créer post par mots-clés",
            to: "ai-factory-post-by-keywords",
            resource: "ai_factory",
            action: "read",
          },
          {
            title: "Créer post par sources",
            to: "ai-factory-post-by-sources",
            resource: ["ai_factory", "leparisien_editorialink"],
            action: "read",
          },
          {
            // Ouverte a ai_factory/read le 2026-09-25, cf. src/router/aiFactory.js.
            title: "Créer post via transcription vidéo",
            to: "ai-factory-post-by-video",
            resource: "ai_factory",
            action: "read",
          },
          {
            title: "Création à partir de sources internes",
            to: "ai-factory-internal-sources",
            resource: "leparisien_editorialink",
            action: "read",
          },
          {
            title: "Créer post via Process Discover",
            to: "ai-factory-post-by-discover",
            resource: "ai_factory",
            action: "read",
          },
          {
            title: "Création auto (Sources)",
            to: "ai-factory-full-auto",
            resource: "ai_factory_full_auto",
            action: "manage",
          },
          {
            title: "Création auto (Mots-clés)",
            to: "ai-factory-keyword-auto",
            resource: "ai_factory_full_auto",
            action: "manage",
          },
          {
            title: "Assistant CTC",
            to: "ai-factory-ctc",
            resource: "ctc",
            action: "manage",
          },
        ],
      },
      {
        title: "🗂️ Analyse / Gestion",
        to: "ai-factory-analysis",
        resource: ["ai_factory", "leparisien_editorialink"],
        action: "read",
        children: [
          {
            title: "Suivi des demandes",
            to: "ai-factory-post-generation-list",
            resource: ["ai_factory", "leparisien_editorialink"],
            action: "read",
          },
          {
            title: "Performances",
            to: "ai-factory-suivi-prod-ia",
            resource: "ai_factory_perf",
            action: "read",
          },
        ],
      },
    ],
  },
];

export default rmrAi;
